import React from "react";

const DraftDispatchContext = React.createContext((action) => {});

export default DraftDispatchContext;
